<template>
    <v-container class="ma-0 pa-0" fluid>
        <v-container>
            <v-layout row>
                <v-flex xs12 sm6 md4 offset-sm1 offset-md1 mt-5>
                    <v-card class="pa-3">
                        <form @submit.prevent="addEmailToList()">
                            <v-text-field
                                v-model="email"
                                label="Invite by Email"
                                :counter="50"
                                :error-messages="errors.collect('email')"
                                v-validate="'email|required'"
                                class="requires--text"
                                data-vv-name="email"
                                data-cy="txtEmail"
                            >
                            </v-text-field>
                            <v-select
                                :items="roleSelect"
                                v-model="selectedRoles"
                                label="Permissions"
                                :error-messages="errors.collect('Role')"
                                v-validate="'required|max:50'"
                                class="requires--text"
                                data-vv-name="Role"
                                data-cy="ddlRoles"
                            >
                            </v-select>
                            <v-textarea outline v-model="comment" label="Optional Message" auto-grow rows="1">
                            </v-textarea>
                            <v-flex text-xs-right mt-2>
                                <v-btn class="hubblue" dark type="submit" data-cy="btnSave">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-flex>
                        </form>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm6 md4 offset-sm1 offset-md1 mt-5>
                    <v-card v-if="emailList.length > 0" class="pa-3">
                        <v-layout row wrap>
                            <template v-for="(email, index) in emailList">
                                <v-flex :key="index" xs12 mt-1>
                                    <v-btn icon @click="removeEmailFromList(index)">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <span>
                                        {{ email }}
                                    </span>
                                    <v-btn icon class="hubblue white--text" @click="showDetails(index)">
                                        <v-icon>mdi-comment-text</v-icon>
                                    </v-btn>
                                    <br />
                                </v-flex>
                            </template>
                            <v-flex xs12 class="text-xs-center mt-5 ml-4">
                                <v-btn class="hubblue" dark @click.prevent="sendMessages()" data-cy="btnSend">
                                    Send Invitation(s)
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <v-dialog persistent v-model="openDialog" max-width="30vw" min-height="10vh">
            <v-toolbar dark class="hubblue">
                <v-btn icon @click.native="openDialog = false" dark>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Email Details</v-toolbar-title>
            </v-toolbar>
            <v-card class="pa-3">
                <p><b> To: </b> {{ displayEmail }}</p>
                <p>
                    <b> Permission: </b>
                    <span>{{ displayRoles }}</span>
                </p>

                <p v-if="displayComment !== ''">
                    <b> Message: </b> <br />
                    {{ displayComment }}
                </p>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios'
import { authHeader } from '../_helpers'

export default {
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            emailList: [],
            emailData: {},
            email: '',
            comment: '',
            displayEmail: '',
            displayComment: '',
            displayRoles: '',
            openDialog: false,

            roleSelect: [{ text: 'Admin', value: 'Admin' }, { text: 'Read Only', value: 'Read Only' }],
            selectedRoles: []
        }
    },
    methods: {
        sendMessages() {
            this.loading = true
            const app = this

            let params = {
                emailList: this.emailList,
                emailData: this.emailData,
                companyId: this.$store.state.authentication.loggedInUser.companyId,
                fullName: this.$store.state.authentication.loggedInUser.fullName,
                email: this.$store.state.authentication.loggedInUser.email,
                originUrl: window.location.origin
            }

            axios
                .post(app.$store.state.userUrl + '/invite', params, { headers: authHeader() })
                .then(response => {
                    app.loading = false
                    let snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    app.back()
                })
                .catch(error => {
                    app.loading = false
                    console.log(error)
                    let snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    this.selectedRoles = []
                    this.emailList = []
                })
        },
        addEmailToList() {
            this.$validator
                .validateAll()
                .then(validated => {
                    if (validated) {
                        let index = this.emailList.findIndex(record => {
                            return record === this.email
                        })
                        if (index < 0) {
                            this.emailList.push(this.email)
                            this.emailData[this.email] = {
                                comment: this.comment,
                                roles: this.selectedRoles
                            }
                        } else {
                            let snackbarParams = {
                                message: 'Email already in the invitation list.',
                                context: 'orange'
                            }

                            this.$store.commit('showSnackbar', snackbarParams)
                        }
                        this.email = ''
                        this.comment = ''
                        this.selectedRoles = []
                    }
                })
                .catch(error => {
                    console.log(error)
                    return false
                })
        },
        showDetails(invite) {
            let emailAddress = this.emailList[invite]
            this.displayEmail = emailAddress
            this.displayRoles = this.selectedRoles.toString()
            this.displayComment = this.emailData[emailAddress].comment
            this.openDialog = true
        },
        removeEmailFromList(index) {
            let emailAddress = this.emailList[index]
            delete this.emailData[emailAddress]
            this.emailList.splice(index, 1)
        },
        back() {
            this.$router.push({ name: 'Dashboard' })
        }
    }
}
</script>
